import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComboSearchSelectModule } from '../combo-search-select/combo-search-select.module';
import {
  ComboTiposPublicosPrioritariosComponent
} from './combo-tipos-publicos-prioritarios.component';

@NgModule({
  declarations: [ComboTiposPublicosPrioritariosComponent],
  imports: [
    CommonModule,
    ComboSearchSelectModule
  ],
  exports: [ComboTiposPublicosPrioritariosComponent]
})
export class ComboTiposPublicosPrioritariosModule { }
